module.exports = __webpack_public_path__ + "static/media/claim-zh-Hant.518bd675.png";